import { Component, Input } from '@angular/core';
import { Characteristic, UserFavoriteCardData } from '../../../user-favorite-data.model';

@Component({
  selector: 'fav-characteristics-icons',
  template: `
    <div class="icons">
      <div class="icon" *ngFor="let item of characteristics">
        <i class="-eva-3-icon-xsm eva-3-icon-{{ item.icon }}"></i>
        <span class="eva-3-caption">{{ item.text }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .icons {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding-left: 12px;
      }

      .icon {
        display: flex;
        gap: 4px;
      }
    `,
  ],
})
export class FavCharacteristicsIconsComponent {
  @Input() characteristics: Characteristic[];
}
